/*
 * @Author: bbqin
 * @Date: 2021-07-20 10:04:42
 * @LastEditTime: 2022-09-01 14:16:54
 * @LastEditors: bbqin
 * @Description: 啥功能呢
 * @FilePath: \Platform_Front\src\platform\base\Calculator\index.js
 * 这锅我不背
 */
import React, { Component } from 'react';
import ModalWrapper from './modal';
import HotKeys from '../HotKeys';
import { getMultiLang } from '@platform/api';

import './index.less';

class Calculator extends Component {
    constructor(props) {
        super(props);
        this.state = {
            langJson: {},
            show: props.show,
        };
    }

    UNSAFE_componentWillMount() {
        let callback = (langJson, bool) => {
            if (bool) {
                this.setState({ langJson });
            }
        };
        getMultiLang({ moduleId: 'container_toast', callback });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.show !== undefined && nextProps.show != this.props.show) {
            this.setState({ show: nextProps.show });
        }
    }

    render() {
        let { hotkey = 'f9', show: pShow, children, ...others } = this.props;
        let { langJson, show } = this.state;
        return <HotKeys
            keyMap={{ openHandler: hotkey }}
            handlers={{
                openHandler: () => {
                    this.setState({ show: true });
                },
            }}
            className="calculator-hotkeys-wrapper"
            // focused={true}
            // attach={document.body}
            display="inline"
        >
            {children}
            {show && <ModalWrapper
                className="calculator-wrapper"
                show={show}
                langJson={langJson}
                onHide={() => {
                    this.setState({ show: false });
                }}
                beSureClick={() => {
                    this.setState({ show: false });
                }}
                cancelClick={() => {
                    this.setState({ show: false });
                }}
                // calculateHandle={(value) => {
                // }}
                {...others}
            />}
        </HotKeys>
    }
}

export default Calculator;